import { render, staticRenderFns } from "./PacklistUpsell.vue?vue&type=template&id=61866f1f&scoped=true"
import script from "./PacklistUpsell.vue?vue&type=script&lang=js"
export * from "./PacklistUpsell.vue?vue&type=script&lang=js"
import style0 from "./PacklistUpsell.vue?vue&type=style&index=0&id=61866f1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61866f1f",
  null
  
)

export default component.exports